import { LoginPage } from '@reactjscomponentrepository/frontend-components/lib/components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logotipo from '../images/logotipo_sim.svg';
import sesionService from '@frontend/useradmin/lib/services/SesionService'
import { ISesion } from '@frontend/useradmin/lib/interfaces/Sesion.model';
import { FormEvent, useEffect } from 'react';
import { encrypt_data } from '../general/functions/Security';
//import storage from '../general/functions/Storage';

export const Login = () => {
  const navigate = useNavigate();
  const login: ISesion = { idUsuario: 0, usuario: "", contraseña: "", token: "", rol: 0 }

  const usrChange = (event: { target: { value: any; }; }) => {
    login.usuario = event.target.value;
  }

  const pwdChange = (event: { target: { value: any; }; }) => {
    login.contraseña = event.target.value;
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    sesionService.openSesion(login)
      .then((response: any) => {
        login.token = response.data.contenido.token;
        localStorage.setItem("token", login.token);
        
        if (response.data.contenido.usuario != null) {
          localStorage.setItem("usuario", response.data.contenido.usuario);
        }
        
        // Guardar ID Usuario
        if (response.data.contenido.idUsuario != null) {
          localStorage.setItem("idUsuario", response.data.contenido.idUsuario);
          login.idUsuario = response.data.contenido.idUsuario;
        }
        
        // Guardar roles desde el campo "rol" (es una string: "2, 3, 18, 3, 4, 1")
        if (response.data.contenido.rol != null && response.data.contenido.rol !== "") {
          // Convertir string de números separados por coma a array de números
          const rolesArray = response.data.contenido.rol
            .split(",")
            .map((id: string) => parseInt(id.trim(), 10))
            .filter((id: number) => !isNaN(id));
          // Encriptar los roles antes de guardarlos
          const encryptedRoles = encrypt_data(JSON.stringify(rolesArray));
          localStorage.setItem("roles", encryptedRoles);
        } else {
          // Si no vienen roles, guardar un array vacío encriptado para evitar errores
          const encryptedRoles = encrypt_data(JSON.stringify([]));
          localStorage.setItem("roles", encryptedRoles);
        }
        
        navigate('/home');
      }, (rechazado: any) => {
          toast.error(rechazado.response.data.result.descripcion)
        })
      .catch((error: any) => {
        toast.error(`Error de autenticación`);
      });
  };
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    //const token = storage.getItem("token");
    token && navigate('/home');
  }, [navigate]);
  
  return (
    <>
      <LoginPage
        systemImage={logotipo} systemImageAlt='SIM - Sistema Integrador de Metadatos' systemName='SIM: '
        systemDescription='Sistema Integrador de Metadatos'
        footerImage=''
        onChangeEmail={usrChange}
        onChangePassword={pwdChange}
        onSubmit={handleSubmit}
        systemDescriptionComplete={<><p className='text-justify mx-5 pt-4'>De conformidad con lo establecido en el artículo 14 de la Norma Técnica para la elaboración de Metadatos de los Procesos de Producción de Información Estadística y Geográfica, el acceso al Sistema Integrador de Metadatos (SIM) está reservado para las personas servidoras públicas designadas como responsables de la captura, revisión y autorización de metadatos.</p></>}
      />
    </>
  )
}